<template>
  <b-card
    class="overflow-hidden"
    no-body
  >
    <b-table
      responsive
      :items="invoices"
      :fields="fields"
    >
      <template #cell(folio)="data">
        <quote-button-route :quote="data.item" />
      </template>
      <template #cell(customer)="">
        <div class="text-primary font-weight-bolder">
          -
        </div>
      </template>
      <template #cell(date)="">
        <div class="">
          {{ getInvoiceDate }}
        </div>
      </template>
      <template #cell(total)="data">
        $ {{ data.value | money }}
      </template>
      <template #cell(content_type)="data">
        <div class="text-primary font-weight-bolder">
          {{ data.value }}
        </div>
      </template>
      <template
        v-if="!noTools"
        #cell(tools)="data"
      >
        <div>
          <b-button
            variant="primary"
            class="p-0 custom-padding mr-1"
            @click="downloadQuoteInovices(data.item)"
          >
            <feather-icon
              icon="DownloadIcon"
              class="text-white"
              size="18"
              color="#000"
            />
          </b-button>
          <b-button
            variant="primary"
            class="p-0 custom-padding"
            :href="quoteInvoicesHref(data.item.id)"
            target="_blank"
            rel="noopener noreferrer"
          >
            <feather-icon
              icon="EyeIcon"
              class="text-white"
              size="18"
              color="#000"
            />
          </b-button>
          <!-- <b-button
            v-if="isAdmin"
            variant="danger"
            class="p-0 custom-padding mr-1"
            @click="deleteInvoice(data.item.id)"
          >
            <feather-icon
              icon="XIcon"
              class="text-white"
              size="18"
              color="#000"
            />
          </b-button> -->
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import QuoteButtonRoute from '@/components/pricing/QuoteButtonRoute.vue'

export default {
  components: {
    BTable,
    QuoteButtonRoute,
  },
  props: {
    invoices: {
      type: Array,
      default() {
        return []
      },
    },
    noTools: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'folio',
          label: 'Folio',
        },
        {
          key: 'customer_name',
          label: this.$t('customer'),
        },
        // {
        //   key: 'date',
        //   label: this.$t('date'),
        // },
        {
          key: 'invoiced_at',
          label: this.$t('invoiceDate'),
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'total',
          label: this.$t('total'),
          tdClass: 'text-left',
          thClass: 'text-left',
        },
        {
          key: 'tools',
          label: this.$t('actions'),
        },
      ],
    }
  },

  computed: {
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters('quotes', ['quote']),
    ...mapGetters('purchaseOrders', ['purchaseOrder']),
    isAdmin() {
      return this.currentUser.role_name === 'admin'
    },

    getInvoiceDate() {
      if (this.$route.name === 'quoteInvoices') {
        return this.quote.invoiced_at
      }
      if (this.$route.name === 'purchaseOrderInvoices') {
        return this.purchaseOrder.invoiced_at
      }
      return 'No hay fecha'
    },
  },

  methods: {
    ...mapActions('quotes', ['downloadQuoteInovices', 'deleteQuoteInovice']),
    ...mapActions('purchaseOrders', [
      'getPurchaseOrderInovices',
      'deletePurchaseOrderInovice',
    ]),
    quoteInvoicesHref(quoteId) {
      return this.$router.resolve({
        name: 'quoteInvoices',
        params: { quoteId },
      }).href
    },

    deleteInvoice(invoiceId) {
      if (this.$route.name === 'quoteInvoices') {
        this.deleteQuoteInovice({
          quoteId: this.$route.params.quoteId,
          invoiceId,
        }).then(() => {
          this.$emit('refetch')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('fileDelted'),
              icon: 'SaveIcon',
              variant: 'success',
            },
          })
        })
      } else if (this.$route.name === 'purchaseOrderInvoices') {
        this.deletePurchaseOrderInovice({
          purchaseOrderId: this.purchaseOrder.id,
          invoiceId,
        }).then(() => {
          this.$emit('refetch')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('fileDelted'),
              icon: 'SaveIcon',
              variant: 'success',
            },
          })
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-padding {
  padding: 3px !important;
}
</style>
